module.exports = __webpack_public_path__ + "img/02.74a09013.jpg";